import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgHeartStraight = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.39 6.234a6.351 6.351 0 0 0-8.96-.01L14 7.551 12.568 6.22a6.344 6.344 0 0 0-8.959 8.984l9.773 9.916a.874.874 0 0 0 1.247 0l9.762-9.916a6.343 6.343 0 0 0 0-8.969Zm-1.24 7.74L14 23.254l-9.155-9.289a4.594 4.594 0 1 1 6.497-6.497l.022.022 2.04 1.898a.875.875 0 0 0 1.192 0l2.04-1.898.022-.022a4.594 4.594 0 1 1 6.492 6.501v.005Z" />
  </svg>
);
export default SvgHeartStraight;
